/* ステップナビゲーション */
import React, { memo } from 'react';
import { convertLine } from '../Convert';

interface Props {
  current: number;
  step1: string;
  step2: string;
  step3: string;
  step4?: string;
  disabled: boolean;
}

const StepNavigation: React.FC<Props> = ({ current, step1, step2, step3, step4, disabled }) => {
  return (
    <div className={`p-step ${disabled ? 'p-step-disabled' : ''}`}>
      <ul className="c-step">
        <li className={current === 1 ? 'is-current' : ''}>{convertLine(step1)}</li>
        <li className={current === 2 ? 'is-current' : ''}>{convertLine(step2)}</li>
        <li className={current === 3 ? 'is-current' : ''}>{convertLine(step3)}</li>
        {step4 && <li className={current === 4 ? 'is-current' : ''}>{convertLine(step4)}</li>}
      </ul>
    </div>
  );
};

export default memo(StepNavigation);
